export default "__VITE_ASSET__a9e8fe28__"